
export const environment = {
   production: true,
   baseUrl: "https://route-planner-dev-api.umlaut-cloud.com",
   envName:'localhost'
};
